import React from "react";
import "./uiPending.scss";

export interface SegmentOption<T extends string> {
  value: T;
  label: React.ReactNode;
  disabled?: boolean;
  title?: string;
}

interface SegmentedControlProps<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  /** Accessible name for the group (the visible Field label, repeated). */
  "aria-label": string;
  id?: string;
}

/**
 * Pending src/ui component: a pill group of mutually exclusive toggle buttons
 * (view, role, layout switches). Each segment is a button with aria-pressed.
 */
function SegmentedControl<T extends string>({ options, value, onChange, id, ...rest }: SegmentedControlProps<T>) {
  return (
    <div className="sa-segmented" role="group" id={id} aria-label={rest["aria-label"]}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={`sa-segmented__item${o.value === value ? " sa-segmented__item--active" : ""}`}
          aria-pressed={o.value === value}
          disabled={o.disabled}
          title={o.title}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
